var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-wrap",on:{"click":_vm.onClick}},[(_vm.checked)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-checkbox-marked")]):_c('v-icon',[_vm._v("mdi-checkbox-blank-outline")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }